import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SupervisorStats from './SupervisorStats';
import TutorStatistics from './TutorStats';

const StatsLanding = ({ isSupervisor }) => {
  if (typeof isSupervisor === 'undefined') return null;
  if (isSupervisor) {
    return <SupervisorStats />;
  }
  return <TutorStatistics />;
};

StatsLanding.propTypes = {
  isSupervisor: PropTypes.bool,
};
export default connect(
  (state) => {
    const { isSupervisor } = state.user;
    return { isSupervisor };
  },
  (dispatch) => ({})
)(StatsLanding);
